<template>
  <v-card color="white" class="elevation-0">
    <v-list dense>
      <template v-for="(item, index) in listItems">
        <v-divider v-if="item.divider" :key="index" />
        <!-- <v-list-item
          v-if="item.content && item.to"
          :key="item.content"
          :to="item.to"
          class="my-2 font-weight-medium defaultColor--text"
          style="font-size:13px"
        >
          <v-list-item-content class="pl-3">
            {{ item.content }}
          </v-list-item-content>
        </v-list-item> -->
        <v-list-item
          v-if="item.content"
          :key="item.content"
          @click="item.click"
          class="py-2 font-weight-medium defaultColor--text"
          style="font-size:13px"
        >
          <v-list-item-content class="pl-3">
            {{ item.content }}
          </v-list-item-content>
          <v-list-item-action v-if="item.action">
            <v-badge
              v-if="notificationLength"
              v-model="show"
              color="error"
              left
            >
              <span slot="badge">{{ notificationLength }}</span>
            </v-badge>
          </v-list-item-action>
        </v-list-item>
      </template>
    </v-list>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      show: true,
      listItems: [],
    };
  },

  mounted() {
    this.createListItems();
  },

  methods: {
    toProfile() {
      this.$router.push("profile/me");
    },

    logOut() {
      this.logout();
    },

    goProfile(){
      this.$router.push({ path: `/myProfile`, query: { tab: 0 } });
    },

    goProfileMyPost(){
      this.$router.push({ path: `/myProfile`, query: { tab: 1 } });
    },

    goProfileMyLiked(){
      this.$router.push({ path: `/myProfile`, query: { tab: 2 } });
    },

    createListItems() {
      //this.$router.push({ path: `/myProfile`, query: { tab: 0 } });
      this.listItems = [
        { content: this.$t("menu.profile"), click: this.goProfile },
        { divider: true },
        { content: this.$t("menu.myPosts"), click: this.goProfileMyPost },
        { divider: true },
        { content: this.$t("menu.myLikes"), click: this.goProfileMyLiked },
        { divider: true },
        { content: this.$t("menu.logout"), click: this.logOut },
      ];
    },
    ...mapActions(["logout"]),
  },

  computed: {
    ...mapGetters(["notificationLength"]),
  },
};
</script>
